export default "### Could not reset password\n\nSorry. Could not reset password. Please try again later."